<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { DamageReport } from '~~/server/api/insurance/bank/insurance'

export interface PagesBankInsuranceDamageReportProps {
    data: DamageReport
}
const props = defineProps<PagesBankInsuranceDamageReportProps>()
</script>
<template>
  <section id="ako-nahlasit-skodovu-udalost">
    <Box
   
      decor-position="top-left"
      color="red"
      class="scroll-margin-top-11"
    >
      <BoxHeader
        heading-level="h2"
        :heading="props.data.title"
      />
      <div class="row">
        <div
          v-for="(item, index) in props.data.report"
          :key="`dri-${index}`"
          class="col-12 col-md-6 col-xl-3"
          :class="{
            'mb-2': index < 3,
            'mb-md-6': index < 2,
            'mb-md-0': index === 2,
            'mb-xl-0': index < 3,
          }"
        >
          <article
            class="rounded bg-white p-3 px-md-5 py-md-11 h-100 d-flex flex-column justify-content-between"
          >
            <div class="mb-4">
              <img
                :src="item.icon.path"
                width="28"
                height="28"
                loading="lazy"
                decoding="async"
                alt=""
                class="d-block mb-2 mx-auto"
              >
              <h3 class="zeta text-black text-center mb-3">
                {{ item.name }}
              </h3>
              <Typo>
                <div v-html="item.description" />
              </Typo>
            </div>
            <div class="d-flex flex-column gap-2">
              <VButton
                v-if="item.primary_cta.url"
                color="primary"
                size="small"
                class="fw-normal"
                :to="item.primary_cta.url"
                :label="item.primary_cta.text"
              >
                {{ item.primary_cta.text }}
              </VButton>
              <VButton
                v-if="item.secondary_cta.url"
                color="secondary"
                size="small"
                class="fw-normal"
                :to="item.secondary_cta.url"
                :label="item.secondary_cta.text"
              >
                {{ item.secondary_cta.text }}
              </VButton>
            </div>
          </article>
        </div>
      </div>
    </Box>
  </section>
</template>
